import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth === true)) {
        store.dispatch('user/checkAuthentication', to.meta.requiresAuth)
            .then((result) => {
                if (!result) {
                    next({
                        name: 'login',
                        query: {
                            redirect: to.fullPath
                        }
                    });
                }
                else {
                    next();
                }
            });
    }
    else {
        next();
    }
});

export default router;
